import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: '1rem',
  },

  areaContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: 'calc(100% - 3rem)',
    marginTop: '2rem',
    '& > h3:': {
      color: Colors.loginLigthenPrimaryColor,
    },
    '& > div': {
      width: '100%',
    },
  },
  
  areaTitle: {
    display:  'flex',
    alignItems: 'center',
    gap: '0.25rem',
    '& > svg': {
      color: Colors.prussianBlue,
    },
  },
  
}))

export default styles
